// extracted by mini-css-extract-plugin
export default {"commentsForum":"Forum_commentsForum__T3M4t","forumContainer":"Forum_forumContainer__lgO5F","totalComments":"Forum_totalComments__9NYKn"};